var TEMPLATE_URL = require('./deskewed.image.html');

angular.module('ikeweb.spike')
    .directive('deskewedImage', ['spikeCaptureService',
        function(spikeCaptureService) {

            return {
                restrict: 'E',
                replace: true,
                templateUrl: TEMPLATE_URL,
                scope: {
                    capture: '=',
                    scaled: '@'
                },
                link: function($scope, $element, $attrs) {
                    $scope.$watch('capture', function() {
                        if (!$scope.capture) {
                            return;
                        }

                        var capture = $scope.capture;

                        spikeCaptureService.getCaptureImageDeskewed(capture, $attrs.scaled === 'y')
                            .then(function(url) {
                                $scope.src = url;
                                $scope.$apply();
                            });
                    });
                }
            };
        }
    ]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/deskewed-image/deskewed.image.directive.js
// module id = 521
// module chunks = 0